<template>

  <div class="leftNav" :class="{ collapsed: isCollapse }">
    <!-- 顶部系统名（不动） -->
    <div class="sysname">
      <img :src="logo"/>
      <span v-show="!isCollapse">{{ $store.state.systemtitle }}</span>
    </div>
    <div class="menu-scroll">
      <el-menu :collapse-transition="false" :default-active="$route.path" class="el-menu-vertical-demo"
               :collapse="isCollapse">

        <template v-for="item in routeNav">
          <el-submenu :index="item.id+''" :key="item.id" v-if="!item.nonav&&!item.file_path">
            <template slot="title">
              <fa-icon :icon="item.ico" v-if="item.ico" style="width: 18px; height: 18px;margin-right: 6px;"></fa-icon>
              <!--            <el-image style="width: 18px; height: 18px;margin-right: 6px;" :src="item.ico" v-if="item.ico"></el-image>-->
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group>
              <el-menu-item :index="ite.path" v-for="ite in item.children" v-if="!ite.nonav"
                            @click="gopage(ite.path)">

                {{ ite.name }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item :index="item.path" v-if="!item.nonav&&item.file_path"
                        @click="gopage(item.path)">
            <!--          <el-image style="width: 18px; height: 18px;margin-right: 6px;" :src="item.ico" v-if="item.ico"></el-image>-->
            <div>


            </div>
            <fa-icon v-if="item.ico" :icon="item.ico" style="width: 18px; height: 18px;margin-right: 6px;"></fa-icon>
            <span>{{ item.name }}</span>
          </el-menu-item>
        </template>


      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      shop: {},
      logo: ''
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.leftnav.isCollapse
    },
    routeNav() {
      return this.$store.state.routeNav
    },
  },
  created() {
    this.shop = JSON.parse(sessionStorage.getItem('shop'))

    this.logo = (sessionStorage.getItem('logo'))
  },
  methods: {
    gopage(path) {
      this.$router.push(path)
    }
  }
}
</script>
<style scoped lang="scss">
.sysname {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  font-size: 17px;
  font-weight: bold;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
  border-right: 1px solid #f0f0f0;
  img { width: 20px; height: 20px; border-radius: 50%; margin-right: 4px; }
}

/* ========= 菜单滚动容器（新增） ========= */
.menu-scroll {
  height: calc(100vh - 56px);   /* 减去顶部标题高度 */
  overflow-y: auto;
  overflow-x: hidden; /* 强制隐藏横向 */
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 #f6f6f6;
}
.menu-scroll::-webkit-scrollbar { width: 4px; }
.menu-scroll::-webkit-scrollbar-track { background: #f6f6f6; border-radius: 2px; }
.menu-scroll::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 2px; }


.el-menu {
  background: #fff !important;
  border: none;
}

::v-deep .el-menu-item-group__title { display: none; }
::v-deep .el-menu-item-group { padding: 0 !important; }

.el-menu-item {
  font-size: 14px;
  color: #333;
  text-align: center;
}
.el-menu-item.is-active {  background: #3A85FE;
  color: white;
  font-size: 14px; }

.el-menu-item, .el-submenu__title {
  height: 44px;
  line-height: 44px;
  display: flex;
  align-items: center;
}

.leftNav {
  width: 200px;
  transition: width .3s;
  overflow: hidden;
  &.collapsed { width: 64px; }
}

.menu-scroll::-webkit-scrollbar { width: 4px; }
.menu-scroll::-webkit-scrollbar-track { background: #f6f6f6; border-radius: 2px; }
.menu-scroll::-webkit-scrollbar-thumb { background: #c1c1c1; border-radius: 2px; }


</style>
